import api from '@common/api';
// 箱信 客服中心码头管理 数据
export const getPriceWharfList = (scope) => {
  return api.get('/resource/wharf/district', {
    params: { scope },
  });
};
